<template>
  <div class="content-item tx-blog blog-entry-list">
    <div class="list__wrapper">
      <div class="list-item" v-for="(item, index) in entries"
           :key="`blog__entry--${item.uid}`"
           :class="{ '-special': isSpecialItem(index)}">
        <a v-if="item.link" :href="item.link">
          <div v-if="item.image" class="list-element__image_wrapper">
            <img :src="item.image.split('|')[0]" :title="item.image.split('|')[1]"
                 :alt="item.image.split('|')[2]" :style="'object-position: ' + item.backgroundPosX + ' ' + item.backgroundPosY">
            <div v-if="item.category.title" class="list-element__category">
              <span>{{ item.category.title }}</span>
            </div>
          </div>
          <div class="list-element__content">
            <div v-if="item.category.title" class="list-element__content-category">
              <span>{{ item.category.title }}</span>
            </div>
            <div class="content__data">
              <div v-if="item.title" class="content__title">
                <span class="heading">{{ item.title }}</span>
              </div>
              <div v-if="item.description" class="content__description">
                <span v-html="item.description"></span>
              </div>
            </div>
          </div>
        </a>
        <div v-if="index===0" class="list-buttons__wrapper">
          <div class="button-item" v-for="(category) in categories"
               :key="`blog__category--${category.uid}`"
               :class="{ '-current': isCurrentCategory(category.uid)}">
            <a v-if="category.link" :href="category.link">
              <div v-if="category.icon" class="category-button__icon">
                <img :src="category.icon.split('|')[0]" :title="category.icon.split('|')[1]"
                     :alt="category.icon.split('|')[2]">
              </div>
              <div class="category-button__title">
                <span>{{ category.title }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="list-item list-item--placeholder"></div>
      <div class="list-item list-item--placeholder"></div>
    </div>
    <div class="content-item module-load-more" v-if="numberOfTotalArticles > 0">
      <div class="load-more__button" v-if="currentPage < numberOfPages">
        <div class="btn -btn-alpha" @click="loadMoreEntries">
          <span>{{ $t('blogEntryList.pagination.button') }}</span>
        </div>
      </div>
      <div class="load-more__progress" v-if="loaded">
        <div class="progress__info">
          <span class="meta" v-html="$t('blogEntryList.pagination.loaded', { current: entries.length, total: numberOfTotalArticles })"></span>
        </div>
        <div class="progress__bar"><span :style="{ width: (entries.length / numberOfTotalArticles * 100) + '%' }"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState({
      entries: 'entries',
      categories: 'categories',
      currentPage: 'currentPage',
      itemsPerPage: 'itemsPerPage',
      numberOfPages: 'numberOfPages',
      numberOfTotalArticles: 'numberOfTotalArticles',
      loaded: 'loaded',
      entriesFilter: 'entriesFilter'
    })
  },
  methods: {
    isSpecialItem: function (index) {
      if (index === 0) {
        return true
      }
      return false
    },
    isCurrentCategory: function (current) {
      if (current.toString() === this.entriesFilter.toString()) {
        return true
      }
      return false
    },
    loadMoreEntries: function () {
      this.increasePage()
      this.getEntries()
    },
    ...mapActions([
      'getEntries',
      'getCategories',
      'increasePage'
    ])
  },
  created () {
    this.getEntries()
    this.getCategories()
  }
}
</script>
